/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * MDLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ArchiveLinkPagesBody} from './schemas/archive-link-pages-body';

import type {CreateLinkPage200} from './schemas/create-link-page200';

import type {CrupdateLinkPageBody} from './schemas/crupdate-link-page-body';

import type {DeleteLinkPagesParams} from './schemas/delete-link-pages-params';

import type {ListLinkPagesParams} from './schemas/list-link-pages-params';

import type {ListLinkPages200} from './schemas/list-link-pages200';

import type {RetrieveLinkPage200} from './schemas/retrieve-link-page200';

import type {UnarchiveLinkPagesBody} from './schemas/unarchive-link-pages-body';

import type {UpdateLinkPage200} from './schemas/update-link-page200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all link pages
 */
export const listLinkPages = (
  params?: ListLinkPagesParams,
  options?: SecondParameter<typeof orvalApiFetch<ListLinkPages200>>,
) => {
  return orvalApiFetch<ListLinkPages200>(
    {url: `/link-pages`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a link page
 */
export const createLinkPage = (
  crupdateLinkPageBody?: CrupdateLinkPageBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateLinkPage200>>,
) => {
  return orvalApiFetch<CreateLinkPage200>(
    {
      url: `/link-pages`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateLinkPageBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a link page
 */
export const retrieveLinkPage = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveLinkPage200>>,
) => {
  return orvalApiFetch<RetrieveLinkPage200>(
    {url: `/link-pages/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a link page
 */
export const updateLinkPage = (
  id: number,
  crupdateLinkPageBody?: CrupdateLinkPageBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateLinkPage200>>,
) => {
  return orvalApiFetch<UpdateLinkPage200>(
    {
      url: `/link-pages/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateLinkPageBody,
    },
    options,
  );
};
/**
 * @summary Delete link pages
 */
export const deleteLinkPages = (
  params: DeleteLinkPagesParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/link-pages/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * @summary Archive link pages
 */
export const archiveLinkPages = (
  archiveLinkPagesBody: ArchiveLinkPagesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/link-pages/bulk/archive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: archiveLinkPagesBody,
    },
    options,
  );
};
/**
 * @summary Unarchive link pages
 */
export const unarchiveLinkPages = (
  unarchiveLinkPagesBody: UnarchiveLinkPagesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/link-pages/bulk/unarchive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: unarchiveLinkPagesBody,
    },
    options,
  );
};
export type ListLinkPagesResult = NonNullable<
  Awaited<ReturnType<typeof listLinkPages>>
>;
export type CreateLinkPageResult = NonNullable<
  Awaited<ReturnType<typeof createLinkPage>>
>;
export type RetrieveLinkPageResult = NonNullable<
  Awaited<ReturnType<typeof retrieveLinkPage>>
>;
export type UpdateLinkPageResult = NonNullable<
  Awaited<ReturnType<typeof updateLinkPage>>
>;
export type DeleteLinkPagesResult = NonNullable<
  Awaited<ReturnType<typeof deleteLinkPages>>
>;
export type ArchiveLinkPagesResult = NonNullable<
  Awaited<ReturnType<typeof archiveLinkPages>>
>;
export type UnarchiveLinkPagesResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveLinkPages>>
>;
